import React from "react";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";
import { DELETE_USER_MUTATION } from "../../../graphql/mutations";

const DeleteUserModal = ({ show, user, handleClose, onUserDelete }) => {
  const navigate = useNavigate();
  const [deleteUser, { loading: mutationLoading }] = useMutation(DELETE_USER_MUTATION);

  const handleDelete = async (e) => {
    e.preventDefault();

    try {
      const { data } = await deleteUser({
        variables: {
          targetEmail: user.email
        }
      });

      if (data?.deleteUser) {
        handleClose();
        if (onUserDelete) {
          onUserDelete(user.email);
        }
        toast.success(`Database user with ID: ${data?.deleteUser} deleted successfully`);
        navigate("/users");
      }
    } catch (error) {
      handleClose();
      setTimeout(() => {
        toast.error("Failed to delete database user.");
      }, 200);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Delete User</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Are you sure you want to delete user{" "}
          <strong>
            {user.firstName} {user.lastName}
          </strong>
          ?
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleClose}>
          No
        </Button>
        <Button variant="danger" onClick={handleDelete}>
          {mutationLoading ? "Deleting user..." : "Yes"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export { DeleteUserModal };
